/**
 * Service Worker Killer + Cache Buster.
 *
 * Defensive cleanup: kalau ada Service Worker yang ter-register dari deploy
 * sebelumnya (CRA default sw, Workbox, atau apapun), unregister & hapus
 * SEMUA Cache Storage. Mencegah bundle JS/CSS lama tertanam di browser user.
 *
 * Safe untuk dipanggil setiap kali app mount — kalau tidak ada SW, function
 * langsung return. Idempotent.
 */
export async function killServiceWorkersAndCaches() {
  try {
    if (typeof navigator === "undefined" || !navigator.serviceWorker) {
      return { unregistered: 0, cachesDeleted: 0 };
    }
    let unregistered = 0;
    let cachesDeleted = 0;

    // 1. Unregister all service workers
    const regs = await navigator.serviceWorker.getRegistrations();
    for (const reg of regs) {
      try {
        const ok = await reg.unregister();
        if (ok) unregistered += 1;
      } catch (_) { /* ignore */ }
    }

    // 2. Delete all Cache Storage entries (HTTP cache from SW)
    if (typeof caches !== "undefined" && caches?.keys) {
      const keys = await caches.keys();
      for (const key of keys) {
        try {
          const ok = await caches.delete(key);
          if (ok) cachesDeleted += 1;
        } catch (_) { /* ignore */ }
      }
    }

    if (unregistered > 0 || cachesDeleted > 0) {
      // Sekali setelah cleanup, force one reload so the page no longer
      // hits cached SW responses. Use a flag in sessionStorage agar tidak
      // infinite loop.
      try {
        if (typeof window !== "undefined" && !sessionStorage.getItem("__sw_killed")) {
          sessionStorage.setItem("__sw_killed", "1");
          console.info(`[swKiller] Cleaned ${unregistered} SW + ${cachesDeleted} caches. Reloading...`);
          window.location.reload();
        }
      } catch (_) { /* ignore */ }
    }

    return { unregistered, cachesDeleted };
  } catch (e) {
    return { error: String(e) };
  }
}
